<template>
  <div class="contais">
    <div class="cons">
      <div class="con">
        <span class="btn">
          <el-input placeholder="请输入票号查找" v-model="inpu" clearable />
          <el-button type="primary" icon="el-icon-search" @click="getDas">搜索</el-button>
        </span>
        <span class="btn">
          <el-input placeholder="请输入名字查找" v-model="input" clearable />
          <el-button type="primary" icon="el-icon-search" @click="getNames"
            >搜索</el-button
          >
        </span>
      </div>
      <div class="co">
        <div class="co_cs">
          <h2>今日赎回：{{ jnum }}</h2>
          <h4>金额：{{zpri}}</h4>
        </div>
        <div class="co_cs">
          <h2>全部赎回：{{ znum }}</h2>
          <h4>金额：{{sumPri}}</h4>
        </div>
      </div>
    </div>
    <div class="contens">
      <el-tabs type="border-card" v-model="activeName">
       <el-tab-pane label="今日赎回"  name="todays">
          <el-table
       :data="todayItems"
        border 
       max-height="850"
        style="width: 100%"
        >
        <el-table-column prop="stas" label="典当状态" width="100" header-align="center" align="center"> </el-table-column>
        <el-table-column prop="ticketnumber" label="票号" width="150" header-align="center" align="center"> </el-table-column>
        <el-table-column prop="name" label="姓名" header-align="center" align="center"> </el-table-column>
        <el-table-column prop="itemname" label="物品名称" width="180" header-align="center" align="center"> </el-table-column>
        <el-table-column prop="xuday" label="操作日期" width="130" header-align="center" align="center"> </el-table-column>
        <el-table-column prop="pri" label="典当金额" header-align="center" align="center"> </el-table-column>
        <el-table-column prop="xupri" label="典当综合费" header-align="center" align="center"> </el-table-column>
        <el-table-column prop="lx" label="典当利息" header-align="center" align="center"> </el-table-column>
        <el-table-column prop="ytdy" label="逾期天数" header-align="center" align="center"> </el-table-column>
        <el-table-column prop="pena" label="罚息" header-align="center" align="center"> </el-table-column>
        <el-table-column prop="yspri" label="应收金额" header-align="center" align="center"> </el-table-column> 
        <el-table-column prop="rece" label="实付金额" header-align="center" align="center"> </el-table-column> 
        <el-table-column prop="couqons" label="优惠券" header-align="center" align="center"> </el-table-column>
        <el-table-column prop="couqonmoney" label="优惠金额" header-align="center" align="center"> </el-table-column>
        <el-table-column prop="xuname" label="操作人" header-align="center" align="center"> </el-table-column>
      </el-table>
       </el-tab-pane>


       <el-tab-pane label="全部赎回业务" name="sum">
         <el-table
       :data="sumItems"
        border 
       max-height="850"
        style="width: 100%">
         <el-table-column prop="dates" label="填表日期" width="160"> </el-table-column>
        <el-table-column prop="piaonum" label="当票号" width="130"> </el-table-column>
        <el-table-column prop="name" label="当户姓名" width="80"> </el-table-column>
        <el-table-column prop="tel" label="联系电话" width="120"> </el-table-column>
        <el-table-column prop="plateNumber" label="车牌号" width="110"> </el-table-column>
        <el-table-column prop="brand" label="汽车品牌" width="100"> </el-table-column>
        <el-table-column prop="radio" label="车辆状态" width="100"> </el-table-column>
        <el-table-column prop="mileage" label="公里数/KM" width="100"> </el-table-column>
        <el-table-column prop="IllegalProcessing" label="违章情况" width="120"> </el-table-column>
        <el-table-column prop="overallValuation" label="车辆估值" width="120"> </el-table-column>
        <el-table-column prop="sum" label="典当金额" width="120"> </el-table-column>
        <el-table-column prop="comprehensive" label="典当综合费" width="100"> </el-table-column>
        <el-table-column prop="lx" label="典当利息" width="100"> </el-table-column>
        <el-table-column prop="startDate" label="开始日期" width="120"> </el-table-column>
        <el-table-column prop="DateClosed" label="到期日期" width="120"></el-table-column>
        <el-table-column prop="det" label="典当天数" width="100"></el-table-column>
        <el-table-column prop="parkingFee" label="停车费" width="120"></el-table-column>
        <el-table-column prop="agent" label="经办人" > </el-table-column>
        <el-table-column prop="reviewer" label="复核" > </el-table-column>
      </el-table>
       </el-tab-pane>
      </el-tabs>

     
    </div>

   
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "ransom",
  data() {
    return {
      inpu: "", //输入框票号
      input: "", //输入框名字
      ACCESS_TOKEN: "",
      znum: 0, //在当合同数量
      jnum: 0, //今日合同数量
      Today: "", //今天的日期
      todayItems: [], //今天数据
      sumItems:[], //所有赎回的数据
      eid: "",
      zpri:0, //今日赎回新增的总金额
      sumPri:0, //全部赎回新增的总金额
      activeName:"todays"
    };
  },
  components: {

  },
  methods: {
    //请求赎回总数量
    getData() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: 'db.collection("car_data").where({state:"赎当"}).limit(1000).get()',
        })
        .then((rus) => {
            rus.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          if(rus.data.errcode !== 0){
            return  this.$notify.error({
              title: '错误提示',
              message: '密钥过期啦，请刷新页面'
            });
          }


           //循环计算今日新增的总金额
        let str = "";
        for (let i in rus.data.data) {
          str += rus.data.data[i].sum;
          str += "+";
        }
        str = str.substring(0, str.length - 1);
        this.sumPri = eval(str);

          this.sumItems = rus.data.data
          this.znum = rus.data.pager.Total;
        });
    },
    //请求今日赎回数量
    getToday() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("yxus_record").where({xuday:_.eq("${this.Today}"),stas:"赎当",type:"汽车"}).limit(1000).get()`,
        })
        .then((days) => {
           days.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
        //循环计算今日新增的总金额
        let str = "";
        for (let i in days.data.data) {
          str += days.data.data[i].pri;
          str += "+";
        }
        str = str.substring(0, str.length - 1);
        this.zpri = eval(str) || 0;

          this.todayItems = days.data.data
          this.jnum = days.data.pager.Total;
        });
    },

    //查找数据--票号
    getDas() {
      if (this.inpu !== "") {
        this.activeName = "sum"
        this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("car_data").where({state:"赎当",piaonum:"${this.inpu}"}).get()`,
          })
          .then((ps) => {
            ps.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.sumItems = ps.data.data;
            if (ps.data.data.length == 0) {
              this.$message({
                message: "没有搜索到结果哦",
                type: "warning",
              });
            }
          });

        return;
      }
      this.$message({
        message: "请输入票号才能查找到数据哦，赶快去输入票号再来搜索吧",
        type: "warning",
      });
    },
    handleClick(eid) {
      this.eid = eid;
      this.ces = !this.ces;
    },
    //查找数据--名字
    getNames() {
      if (this.input !== "") {
        this.activeName = "sum"

        this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("car_data").where({state:"赎当",name:"${this.input}"}).get()`,
          })
          .then((ns) => {
            ns.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.sumItems = ns.data.data;
            if (ns.data.data.length == 0) {
              this.$message({
                message: "没有搜索到结果哦",
                type: "warning",
              });
            }
          });

        return;
      }
      this.$message({
        message: "请输入名字才能查找到数据哦，赶快去输入名字再来搜索吧",
        type: "warning",
      });
    },
  },
  created() {
    // this.ACCESS_TOKEN = localStorage.getItem("ACCESS_TOKEN"); //ACCESS_TOKEN
       //获取到this.ACCESS_TOKEN
     this.getTokens()
    this.Today = dayjs().format("YYYY-MM-DD");

     //获取当前登录的用户数据
    this.getUserToken()
  },
  mounted() {
    setTimeout(()=>{
      this.getData();
    this.getToday();
    },800)
    
  },
};
</script>
<style scoped>
/* h1{
  font-size: 1em;
  width: 6em;
} */
.cons {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.con {
  width: 60%;
  height: 200px;
  background-color: #ffffff;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.co {
  width: 39%;
  height: 200px;
  background-color: #ffffff;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.co_cs {
  width: 35%;
  height: 60%;
  background-color: #43c096;
  border-radius: 8px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  font-weight: bold;
}
.co_cs h4{
  margin: 0 0 ;
} 

.contens {
  width: 100%;
  background-color: #ffffff;
  margin: 20px auto;
}
.conten {
  width: 100%;
  height: 500px;
  background-color: #ffffff;
  margin: 20px auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.btn {
  /* width: 30%; */
  display: flex;
  flex-direction: row;
}
</style>
